function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "base",
  d: "M1033.7,677.6C981,652,965,660.3,912.1,635.3c-31-14.7-77.7-37.4-83.5-74c-0.5-3-0.9-22.1-0.9-22.1 s0.3-3.8,0.7-9.5c35,27.2,85.1,41,89.5,35.5c1.2-1.6-1.6-4.2-5.5-8.8c-18.9-22.2-26.6-49-42.1-102.7c-6.8-23.6-6.7-28-11.5-29.1 c15.5-12.1,21-35.4,23.1-48.2c1.7-10.7,16.4-32.8,12.4-46.3c-3.2-10.9-8.1-10.3-12.6-6.5c1.9-6.3,3.5-13,4.8-20 c3.5-19,1-23.3,2.2-54.2c2.3-58.3,11.9-66.4,10.4-94.3c-2.8-52.8-40.7-91.1-50.5-101C788.5-6.5,706.7-0.4,691.9,0.7 c-62.7,4.7-118.7,37.4-150.8,81c-18.1,24.6-23.8,46.1-26,57.9c-4.2,22.6-5.3,62.7,13.2,79.8c-0.2,4.9,0.8,9.8,2.7,14.1 c-0.1,9.5,7.3,27.5,5.6,53.9c-1.1,17.9-5.1,19.2-3.7,32.7c2.4,23.3,16.8,44.5,22.9,43.1c0.3,0.5,0.6,1,1,1.5 c3.5,5.5,13.9,22.6,20.1,45.5c0.8,3,3,16.2,7.4,42.3c0.3,2,0.6,3.8,0.9,5.4c-2.4,1.5-3.4,6.5-9.1,22.8c-15.2,43.2-22.8,64.9-38.1,82 c-3.2,3.5-5.4,5.5-4.6,6.9c3.2,5.7,53.6-6.4,79.9-34.9c1-1.1,1.7-1.9,2.3-2.7c0.8,1.7,1.4,2.7,1.4,2.9c0,0,5,16,1.1,34.9 c-7.3,34.9-66.8,65.4-89.9,77.2c-40.9,20.9-61.3,31.4-88.8,37c-7.4,1.5-27,5.1-48.6,18c-11.4,6.8-24.4,14.5-24.2,19.3 c1.4,35.3,725.9,56.2,731.6,0C1099.4,709.5,1069,694.7,1033.7,677.6z"
});

function SvgNewBowie(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1448.5 756.1",
    style: {
      enableBackground: "new 0 0 1448.5 756.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "bowie-color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bowie-hair-left-wing_1_",
    style: {
      display: "inline",
      fill: "#D12020"
    },
    d: "M586.6,457.4c-3.5,0.6-3.8,4.2-10.5,23.2 c-15.2,43.2-22.8,64.9-38.1,82c-3.2,3.5-5.4,5.5-4.6,6.9c3.2,5.7,53.6-6.4,79.9-34.9c1.5-1.6,2.2-2.4,3.1-3.7 C633.5,505.8,600.5,455.1,586.6,457.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bowie-hair-right-wing_1_",
    style: {
      display: "inline",
      fill: "#D12020"
    },
    d: "M858.9,424.7c4.8,1.1,4.7,5.5,11.5,29.1 c15.5,53.6,23.3,80.5,42.1,102.7c3.9,4.6,6.7,7.2,5.5,8.8c-5.1,6.5-73.4-13.7-106.1-50.8c-1.8-2.1-2.8-3.2-3.8-4.9 C787.9,477.5,840,420.3,858.9,424.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#140808"
    },
    d: "M1033.7,677.6C981,652,965,660.3,912.1,635.3c-31-14.7-77.7-37.4-83.5-74 c-0.5-3-0.9-22.1-0.9-22.1s4.7-64,8.1-66.7c4.8-9.7,11.8-39.1,23.1-48c15.5-12.1,21-35.4,23.1-48.2c1.7-10.7,16.4-32.8,12.4-46.3 c-7.8-26.4-25.5,14.9-23.6,5.5c3.3-16.4,19.2-54,17.1-72.4c-2.1-18.3-1.1-35.1,1.1-68.7c3.4-53.8-17.5-50.8-21.2-69.3 c-5.2-26.1-19.4-32.5-40.9-56.7c-17.6-19.8-23.5-9.3-43-20.1c-43.7-24-78.3-19.6-101.8-15.8c-31.1,5.1-28,0.5-46.6,9.3 c-19.4,9.1-43.1,18-66,39.4c-20.9,19.5-37.2,45.4-40.9,69.6c-1.8,11.4-12.2,4.6-3.3,41.4c6.7,27.7,7.5,25.5,9.5,38.1 c4.4,27.8,2.9,54.5,2.1,64.5c-1.7,22.5-4.5,26.9-1.1,38.1c3.9,12.8,9.5,13.4,21.1,31.7c3.5,5.5,13.9,22.6,20.1,45.5 c0.8,3,3,16.2,7.4,42.3c0.5,2.8,0.9,5.3,1.3,7.5c-0.1,0-0.1-0.1-0.2-0.1c-1.2,12.2,31.2,73.3,31.7,75.1c0,0,5,16,1.1,34.9 c-7.3,34.9-66.8,65.4-89.9,77.2c-40.9,20.9-61.3,31.4-88.8,37c-7.4,1.5-27,5.1-48.6,18c-11.6,6.8-24.6,14.5-24.4,19.3 c1.4,35.3,725.9,56.2,731.6,0C1099.4,709.5,1069,694.7,1033.7,677.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "bowie-bolt_1_",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2787D6",
      stroke: "#000000",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    points: "702.9,207.2 823.4,191.8 687.9,351.9 762.7,317.4 639.5,506.8 659,421.4 672.2,374 604.6,404.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#070505"
    },
    points: "707.2,206.6 829.5,191.8 680,360.8 768.8,311.3 642.4,502.6 663.5,417.2 675.9,373.1 608.4,402.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D12020"
    },
    points: "711.6,206.1 834,189.4 713.5,333.2 802.3,293.2 646.3,497.2 669.6,411.7 681.5,370.5 615.2,399.9  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "bowie-hair_1_",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D12020"
    },
    d: "M899.2,155.2c-2.8-52.8-40.7-91.1-50.5-101C788.5-6.5,706.7-0.4,691.9,0.7 c-62.7,4.7-118.7,37.4-150.8,81c-18.1,24.6-23.8,46.1-26,57.9c-4.2,22.6-5.3,62.7,13.2,79.8c-0.2,4.9,0.8,9.8,2.7,14.1 c-0.1,9.5,7.3,27.5,5.6,53.9c-1.1,17.9-5.1,19.2-3.7,32.7c2.4,23.4,16.9,44.7,23,43.1c4.2-1.1,2.5-12.8,3.7-37.9 c2.7-58.3,16-82.2,3.7-94.4c0.4-1.3,0.7-2.6,1-4c1.1-0.3,2.2-0.7,3.3-1.2c1.1-0.4,0.6-0.3,3.1-1.4c6.6-2.9,18.5-8.2,27.5-8.9 c9.7-0.8,17.1,3.7,21.5,5.9c27.2,13.9,90.4,19,129.2-6.7c13.7-9.1,18-17.8,29-17.1c10.3,0.7,13.8,8.8,40.1,26 c13.7,8.9,13.3,7.1,16.3,10.4c12.4,13.4,4.6,27.6,9.7,61.6c3.6,24.1,8.8,25,9.7,46.1c1,23.5-4.9,36.1-2.2,37.1 c4.4,1.7,27.1-31.8,34.9-75c3.5-19,1-23.3,2.2-54.2C891,191.2,900.6,183.1,899.2,155.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bowie-maze"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M886.1,534.7v-6.9v-6.9h3.2h2.4c-0.9-2.2-1.8-4.5-2.7-6.9h-9.4v10.3v10.3h3.2h3.3 V534.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M866.9,162.9h9.6h9.6v-13.8v-13.8h6.4h3.9c-1.6-7.3-3.8-14.2-6.4-20.7h-3.9h-12.8 v-3.4v-3.4H887c-1.1-2.4-2.2-4.7-3.4-6.9h-16.8v10.3v10.3h12.8h12.8v3.4v3.4h-16h-16v-17.2V94h6.4h6.4V83.7 c-2.5-3.7-5.1-7.2-7.5-10.3h-2.1h-3.2v-6.5c-2.4-2.8-4.6-5.2-6.5-7.3h-3.1h-9.6v13.8v13.8H838h-3.2v-6.9v-6.9h-9.6h-9.6v6.9v6.9 h-12.8H790v3.4V94h6.4h6.4v3.4v3.4h-19.2h-19.2v6.9v6.9h-3.2H758v-10.3V94h12.8h12.8v-6.9v-6.9h12.8h12.8v-6.9v-6.9H822h12.8v-6.9 v-6.9h6.4h5.9c-2.4-2.4-4.9-4.7-7.4-6.9h-24.1H790v6.9v6.9h-3.2h-3.2v-6.9v-6.9h-12.8H758V39v-6.9h-6.4h-6.4v-3.4v-3.4H758h12.8 v-6.9v-6.9h3.2h3.2v6.9v6.9h3.2h3.2V12.7c-6.5-2.4-13-4.4-19.2-6v4.7v6.9h-3.2H758v-6.9V5.2c-1.1-0.2-2.2-0.5-3.3-0.7h-3.1v6.9v6.9 h-6.4h-6.4v10.3V39h6.4h6.4v6.9v6.9h6.4h6.4v3.4v3.4H758h-6.4v10.3v10.3h9.6h9.6v-3.4v-3.4h-6.4H758V70v-3.4h6.4h6.4v-6.9v-6.9h3.2 h3.2v6.9v6.9h9.6h9.6v-6.9v-6.9h16h16v3.4v3.4h-12.8h-12.8v6.9v6.9H790h-12.8v6.9v6.9h-12.8h-12.8v17.2v17.2h6.4h6.4v3.4v3.4h-12.8 h-12.8v6.9v6.9h-3.2h-3.2v-6.9v-6.9H726h-6.4V125v-3.4h6.4h6.4v-6.9v-6.9h3.2h3.2v6.9v6.9h3.2h3.2v-10.3V101h-6.4h-6.4v-3.4V94h6.4 h6.4V69.9v-24h-6.4h-6.4V39v-6.9H726h-6.4v-3.4v-3.4h6.4h6.4v-3.4v-3.4h-9.6h-9.6v10.3V39h6.4h6.4v6.9v6.9h6.4h6.4V70v17.2h-6.4 H726V101v13.8h-6.4h-6.4V125v10.3h6.4h6.4v3.4v3.4h-6.4h-6.4v3.4v3.4H726h12.8v3.4v3.4H726h-12.8V166v10.3h16h16v-3.4v-3.4h-12.8 h-12.8v-3.4v-3.4h12.8h12.8v-13.8v-13.8H758h12.8v-6.9v-6.9h3.2h3.2v6.9v6.9h3.2h3.2V125v-10.3h-6.4h-6.4v-3.4v-3.4H790h19.2V101 v-7h6.4h6.4v-6.9v-6.9h3.2h3.2v6.9V94h6.4h6.4v13.8v13.8h3.2h3.2V94V66.5h3.2h3.2v6.9v6.9h6.4h6.4v3.4v3.4h-6.4H854v24.1v24.1h12.8 h12.8v10.3V156h-3.2h-3.2v-6.9v-6.9h-9.6H854v10.3v10.3h3.2h3.2V156v-6.9h3.2h3.2v6.9L866.9,162.9L866.9,162.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M879.7,93.8V94h0.2C879.8,94,879.8,93.9,879.7,93.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M911.8,644.8v-9.7c-2.1-1-4.2-2-6.4-3.1v5.8v6.9h3.2L911.8,644.8L911.8,644.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M888.4,286.8c0.1-2.2,0.1-4.5,0.1-6.9h-2.4v-3.4V273h2.3c0-2.1,0-4.4,0-6.9h-8.7 v10.3v10.3h6.4h2.3V286.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M899.2,156h-0.3v-3.4v-0.3c-0.3-3.4-0.7-6.7-1.2-10h-5.2v10.3v10.3h6.4h0.3 C899.3,160.7,899.3,158.4,899.2,156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M854.1,286.8h9.6h9.6V273v-13.8h12.8h2.4c0-2.1,0.1-4.4,0.2-6.9h-2.5v-6.9v-6.9H883 h-3.2v6.9v6.9h-6.4H867v13.8v13.8h-3.2h-3.2v-13.8v-13.8h-51.3H758V249v-3.4h6.4h6.4v-3.4v-3.4h-9.6h-9.6V249v10.3h51.3h51.3V273 L854.1,286.8L854.1,286.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M866.9,238.6h-12.8h-12.8v3.4v3.4h16h16v-10.3v-10.3h-6.4h-6.4v-3.4V218h9.6h9.6v6.9 v6.9h9.6h0.4c0.2-2.4,0.4-4.7,0.6-6.9h-1h-3.2V218v-6.9h-12.8h-12.8v-13.8v-13.8h-3.2h-3.2v24.1v24.1h6.4h6.4v3.4V238.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M879.7,507.1h6.9c-2.3-6.5-4.5-13.6-6.9-21.5v0.8V507.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M1091.3,727.4V724v-3.4h-6.4h-6.4v-3.4v-3.4h16h0.7c-2.3-2.8-5.8-5.7-10.3-8.8v1.9 h-6.4h-6.4v10.3v10.3h9.6L1091.3,727.4L1091.3,727.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M700.3,4.5v6.9h9.6h9.6V4.5V0.2c-2.2-0.1-4.4-0.2-6.4-0.2v4.5h-3.2h-3.2V0 c-2.4,0-4.5,0.1-6.4,0.2V4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M825.2,39h6.2c-5.2-4-10.5-7.6-15.8-10.9V39H825.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M892.5,522.8v5v6.9h5.5C896.1,530.9,894.3,527,892.5,522.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M796.4,18.3V18c-2.1-1-4.3-1.9-6.4-2.8v3.1v13.8h-12.8h-12.8v3.4V39h16h16v-6.9v-6.9 h3.2h3.2v6.9V39h3.2h3.2V28.6v-4.3c-4-2.2-8-4.2-12-6.1h-0.8V18.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M911.8,566.4v-0.7v-3.4h5.6c-1-1.5-2.8-3.4-4.8-5.8c-2.6-3-4.9-6.2-7.1-9.4v8.3v10.2 C907.8,566,910,566.3,911.8,566.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M866.9,610.8v6.5h10.3C873.7,615.2,870.3,613.1,866.9,610.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M1077,699.9c-5.3-3.1-11.3-6.3-17.8-9.7v9.7h9.6H1077z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M1098.2,720.6h-0.6v2.8c0.3-0.7,0.5-1.4,0.5-2 C1098.2,721.1,1098.2,720.8,1098.2,720.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M738.7,720.6h-6.4h-6.4v3.4v3.4h9.6h9.6v-10.3v-10.3h-16h-16v6.9v6.9h-3.2h-3.2v-6.9 v-6.9h-6.4h-6.4v-6.9V693h-6.4h-6.4v-20.7v-20.7h-3.2h-3.3v27.5v27.5h-16h-16v-6.9V693h-16h-16v6.9v6.9h-3.2h-3.2v-10.3v-10.3H617 h12.8v-13.8v-13.8h6.4h6.4v-37.9v-37.9h-3.2h-3.2v13.8v13.8H633h-3.2v-6.9v-6.9h-19.2h-7.7c-2.2,2.3-4.5,4.6-6.9,6.9h1.8h12.8v3.4 v3.4h-16H588c-2.9,2.4-6,4.7-9.1,6.9h12.4h25.6v-6.9v-6.9h3.2h3.2v6.9v6.9h6.4h6.4v3.4v3.4h-12.8h-12.8v3.4v3.4h6.4h6.4v6.9v6.9 h3.2h3.2v-6.9v-6.9h3.2h3.2v10.3v10.3h-6.4h-6.4v13.8V679h-12.8h-12.8v17.2v17.2h12.8h12.8v3.4v3.4h-12.8h-12.8v20.7v10.5 c2.1,0.1,4.3,0.2,6.4,0.3v-10.8h6.4h6.4v-3.4v-3.4h-6.4h-6.4v-3.4v-3.4h9.6h9.6v6.9v6.9h6.4h6.4v3.4v3.4h-12.8h-12.8v4.2 c10.5,0.4,21.2,0.9,32,1.2v-8.9v-10.3h-6.4h-6.4v-13.8v-13.8h-6.4h-6.4v-3.4v-3.4h9.6h9.6v6.9v6.9h12.8h12.8V724v10.3h-3.1h-3.2 v-6.9v-6.9h-9.6h-9.6v3.4v3.4h6.4h6.4v6.9v6.9h9.6h9.6v-13.8v-13.8h6.4h6.4v-6.9v-6.9h3.2h3.2v6.9v6.9h6.4h6.4v3.4v3.4h-12.8h-12.8 v24.1v9.9c2.1,0.1,4.3,0.1,6.4,0.2v-10v-17.2h19.2h19.2v-6.9v-6.9h9.6h9.6v3.4L738.7,720.6L738.7,720.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M649,748.1v5.6c6.4,0.2,12.8,0.4,19.2,0.6v-2.8v-3.4h-9.6L649,748.1L649,748.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M411.8,706.8h-3.2h-3.2v10.3v10.3h6.4h6.4v6.9v2.8c2.1,0.3,4.2,0.6,6.4,0.9v-10.6 v-13.8h3.2h3.2v6.9v6.9h9.6h9.6V724v-3.4h-6.4h-6.4v-3.4v-3.4h12.8H463v-3.4V707h-6.4h-6.4v-3.4v-3.4h9.6h9.6v10.3v10.3H463h-6.4 v21.3c2.1,0.2,4.2,0.4,6.4,0.7v-1.3h3.2h3.2v1.9c2.1,0.2,4.2,0.4,6.4,0.6v-9.4h-6.4H463v-3.4v-3.4h6.4h6.4v-17.2V693h-16h-16v6.9 v6.9H431h-12.8v6.9v6.9H415h-3.2v-6.9C411.8,713.7,411.8,706.8,411.8,706.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M1027.2,745.4v-11.1h-6.4h-6.4v-6.9v-6.9h-3.2h-3.2v10.3v10.3h6.4h6.4v5 C1022.9,746,1025.1,745.7,1027.2,745.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M725.9,0.6v4v6.9h9.6h9.6V2.8c-2.2-0.3-4.3-0.6-6.4-0.9v2.7h-3.2h-3.2V1.1 C730.1,0.9,728,0.7,725.9,0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M860.5,755.5v-7.4h-6.4h-6.4v-6.9v-6.9h-6.4h-6.4v-6.9v-6.9h-3.2h-3.2v13.8v13.8 h-9.6h-9.6v-13.8v-13.8h-12.8h-12.9v-6.9v-6.9h-12.8H758v-3.4v-3.4h6.4h6.4V693v-6.9h3.2h3.2v6.9v6.9h9.6h9.6V693v-6.9h6.4h6.4 v-10.3v-10.3h-6.4h-6.4v-6.9v-6.9h-9.6h-9.6v6.9v6.9h-12.8h-12.8v10.3v10.3h3.2h3.2v-6.9v-6.9h12.8h12.8v-6.9v-6.9h3.2h3.2v6.9v6.9 h6.4h6.4v3.4v3.4h-6.4H790v6.9v6.9h-3.2h-3.2V686v-6.9H774h-9.6v6.9v6.9h-9.6h-9.6v-13.8v-13.8h-12.8h-12.8V662v-3.4h12.8h12.8 v-13.8V631H758h12.8v-13.8v-13.8h9.6h9.6v10.3V624h-3.2h-3.2v-6.9v-6.9h-3.2h-3.2v10.3v10.3h9.6h9.6v-17.2v-17.2h-16h-16v13.8V624 h-3.2H758v-24.1V576h3.2h3.2v6.9v6.9h19.2h19.2v13.8v13.8h9.6h9.6v-6.9v-6.9h3.2h3.2v13.8v13.8h3.2h3.2v-6.9v-6.9h6.4h6.4v-17.2 v-4.8c-3.9-3.9-7.4-8-10.3-12.4h-2.5H822v-27.5V528h-12.8h-12.8v-3.4v-3.4h12.8H822V514v-6.9h3.2h3.2v13.8v9.3c0-0.1,0-0.3,0-0.4 c2.2,1.7,4.4,3.3,6.7,4.9h2.9h9.6v-6.9v-6.9h6.4h6.4v-3.4V514H854h-6.4v-20.7v-20.7H838h-9.6v6.9v6.9h-9.6h-9.6V483v-3.4h6.4h6.4 v-6.9v-6.9h12.8h12.8v-6.9V452h3.2h3.2v13.8v13.8h3.2h3.2v-13.8V452h6.4h3c-1.2-4.2-2.2-7.7-3-10.7v3.8h-3.2h-3.2V428v-2.7 c-0.5-0.3-1-0.5-1.6-0.6c0.6-0.4,1.1-0.9,1.6-1.3v-12.6h3.2h3.2v5.6c2.5-3.3,4.6-7,6.4-10.7v-1.8h-9.6H854v20.7v20.7h-3.2h-3.2 v-13.8v-13.8h-6.4h-6.4v-3.4v-3.4h6.4h6.4V404v-7h12.8h12.8v-6.9v-6.9h6.4h1c0.5-2.5,0.9-4.7,1.3-6.7c0.5-3.2,2.2-7.4,4.2-12.2 v-1.8h-6.4h-6.4v-6.9v-6.9h-12.8h-12.8v-3.4v-3.4h6.4h6.4v-3.4V335h-6.4h-6.4v-3.4v-3.4h6.4h6.4v-6.9v-6.9h3.2h3.2v13.8V342h6.4 h6.4v6.9v6.9h9.6h0.4c0.9-2.3,1.8-4.6,2.6-6.9h-3h-3.2v-10.3v-10.3h6.4h1.2c-1.7-4.6-3.8-6.6-6-6.9h-1.3c-1.6,0.2-3.2,1.1-4.7,2.5 c0.2-0.8,0.5-1.6,0.7-2.5h-2.7v6.9v6.9h-3.2h-3.2v-13.8v-13.8h-9.6h-9.6v6.9v6.9h-6.4h-6.4v17.2v17.2h6.4h6.4v13.8v13.8h3.2h3.2 v-13.8v-13.8h3.2h3.2v6.9v6.9h6.4h6.4v3.4v3.4h-6.4h-6.4v6.9v6.9h-12.8h-12.8v6.9v6.9h-3.2h-3.2v-7v-6.9h-3.2h-3.2v17.2v17.2h6.4 h6.4v17.2v17.2h-12.8h-12.9v6.9v6.9h-3.2h-3.2v-34.4v-34.4h-6.4h-6.4v-3.4V397h9.6h9.6v20.7v20.7h6.4h6.4v3.4v3.4H822h-6.4v3.4v3.4 h9.6h9.6v-10.3v-10.3h-6.4H822v-20.7V390h-16h-16v10.3v10.3h6.4h6.4v48.2V507h3.2h3.2v-6.9v-6.9H822h12.8v-6.9v-6.9h3.2h3.2v24.1 v24.1H838h-3.2V514v-13.8h-9.6h-9.6v6.9v6.9H806h-9.6v-13.8v-13.8h-3.2H790v34.4v34.4h-3.2h-3.2v-6.9v-6.9h-12.8H758v-6.9v-6.9 h-22.4h-22.4v6.9v6.9H710h-3.2v-6.9v-6.9h-6.4H694v-10.3V507h3.2h3.2v6.9v6.9h3.2h3.2V507v-13.8h6.4h6.4v-6.9v-6.9h3.2h3.2v10.3 V500h-6.4h-6.4v10.3v10.3h9.6h9.6v-3.4V514H726h-6.4v-3.4v-3.4h6.4h6.4v-20.7v-20.7h3.2h3.2v13.8v13.8h16h16V483v-10.3h-6.4H758 v-3.4v-3.4h12.8h12.8V459v-6.9h3.2h3.2v10.3v10.3h-6.4h-6.4v27.5v27.5H774h-3.2V514v-13.8h-16h-16v10.3v10.3h9.6h9.6v-3.4V514h-6.4 h-6.4v-3.4v-3.4h9.6h9.6V521v13.8h9.6h9.6v-27.5v-27.5h6.4h6.4v-17.2v-17.2h-16h-16v3.4v3.4h6.4h6.4v3.4v3.4h-12.8h-12.8v10.3v10.3 h6.4h6.4v3.4v3.4h-9.6h-9.6v-13.8v-13.8h-9.6H726v6.9v6.9h-19.2h-19.2V483v10.3h3.2h3.2v-6.9v-6.9h9.6h9.6v3.4v3.4h-6.4h-6.4v6.9 v6.9H694h-6.4V514v13.8h-6.4h-6.6v3.4v3.4h12.8h12.8v17.2V569H697h-3.2v-13.8v-13.8h-9.6h-9.6v24.1v24.1h6.4h6.4v3.4v3.4H681h-6.4 v6.9v6.9H665h-9.6v-10.3v-10.3h3.2h3.2v6.9v6.9h3.2h3.2v-10.3v-10.3h-9.6H649V600v17.2h6.4h6.4v3.4v3.4h-6.4H649v3.4v3.4h9.6h9.6 v-6.9V617h9.6h9.6v3.4v3.4H681h-6.4v3.4v3.4h9.6h9.6v-10.3V610h-6.4H681v-3v-3.4h9.6h9.6v6.9v6.9h3.2h3.2V607v-10.3h-6.4h-6.4v-6.9 v-6.9h-6.4H681v-17.2v-17.2h3.2h3.2v13.8V576h6.4h6.4v6.9v6.9h6.4h6.4v13.8v13.8h6.4h6.4v10.3V638h-3.2h-3.2v-6.9v-6.9h-9.6h-9.6 v6.9v6.9h-25.6H649v13.8v13.8h-6.4h-6.4v10.3v10.3h3.2h3.2v-6.9v-6.9h6.4h6.4v-6.9v-6.9h3.2h3.2v10.3v10.3h-6.4H649v10.3v10.3h9.6 h9.6v-3.4V693h-6.4h-6.4v-3.4v-3.4h6.4h6.4V669v-17.2h-6.4h-6.4v-3.4V645h22.4h22.4v3.4v3.4h-6.4h-6.4V669v17.2h19.2h19.2v3.4v3.4 H713h-12.8v3.4v3.4h16h16v-10.3v-10.3h-12.8h-12.8v-6.9v-6.9h-3.2h-3.2v6.9v6.9H697h-3.2v-10.3v-10.3h6.4h6.4v-13.8V631h3.2h3.2 v6.9v6.9h9.6h9.6v-20.7v-20.7h3.2h3.2v6.9v6.9h3.2h3.2V600v-17.2h-3.2h-3.2v6.9v6.9h-6.4h-6.4v6.9v6.9h-3.2h-3.2v-10.3v-10.3h6.4 h6.4v-6.9V576h6.4h6.4v-6.9v-6.9h12.8h12.8v-3.4v-3.4h-16h-16v6.9v6.9h-6.4h-6.4v6.9v6.9h-9.6h-9.6v-17.2v-17.2h6.4h6.4v-6.9v-6.9 h16h16v3.4v3.4h-12.8h-12.8v6.9v6.9h-6.4H713v10.3V576h3.2h3.2v-6.9v-6.9h6.4h6.4v-6.9v-6.9h22.4H777v6.9v6.9h9.6h9.6v-13.8v-13.8 h9.6h9.6v27.5v27.5h12.8H841v10.3v10.3h-3.2h-3.2v-6.9v-6.9H825h-9.4v6.9v6.9h-3.2h-3.2v-13.8v-13.8H790h-19.2v-3.4V576H790h19.2 v-17.2v-17.2H806h-3.2v13.8v13.8h-25.6h-25.6v27.5v27.5h-6.4h-6.4V638v13.8H726h-12.8V662v10.3H726h12.8v13.8v13.8h6.4h6.4v6.9v6.9 h12.8h12.8v6.9v6.9H790h12.8v13.8V755h12.8h12.8v0.9c2.1,0,4.3,0,6.4-0.1V755v-13.8h3.2h3.2v6.9v6.9h6.4h6.4v0.6 C856.2,755.5,858.4,755.5,860.5,755.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M764.3,748.1v6.9v1c2.1,0,4.3,0,6.4,0v-1h3.2h3.2v1.1c2.1,0,4.3,0,6.4,0V755v-6.9 h-9.6H764.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M911.8,658.6h6.4h6.4v-3.4v-3.4h-16h-16v27.5v27.5h-6.4h-6.4v6.9v6.9h-3.2h-3.2 v-10.3V700h6.4h6.4v-10.3v-10.3H883h-3.2v6.9v6.9h-6.4H867v20.7v20.7h-3.2h-3.2v-6.9v-6.9h-6.4h-6.4v-3.4V714h6.4h6.4v-10.3V693 h-6.4h-6.4v-6.9v-6.9h-6.4H835v-6.9v-6.9h-6.4h-6.4v-6.9v-6.9h-6.6h-6.4v-10.3V631h3.2h3.2v6.9v6.9h6.4h6.4v6.9v6.9h6.4h6.4v6.9 v6.9h9.6h9.6v-6.9v-6.9h6.4h6.4v-13.8V631h3.2h3.2v17.2v17.2h-6.4h-6.4v6.9v6.9h-6.4H854v3.4v3.4h9.6h9.6v-6.9v-6.9h6.4h6.4v-13.8 v-13.8h6.4h6.4v-6.9v-6.9h3.2h1c-3.5-1.7-7-3.4-10.6-5.3v5.3v6.9h-3.2H886v-6.9v-6.9h-9.6h-9.6v13.8v13.8h-3.2h-3.2v-41.3V606 c-2.2-1.6-4.3-3.3-6.4-5.1V624h-6.4h-6.4v10.3v10.3h3.2h3.2v-6.9v-6.9h3.2h3.2V648v17.2h-3.2h-3.2v-6.9v-6.9h-6.4h-6.4v-6.9v-6.9 h-6.4H822v-6.9v-6.9h-9.6h-9.6v6.9v6.9h-19.2h-19.2v6.9v6.9h-3.2H758v-6.9v-6.9h-3.2h-3.2v10.3v10.3h9.6h9.6v-6.9v-6.9h16h16v6.9 v6.9h6.4h6.4v6.9v6.9h6.4h6.4v3.4v3.4H822h-6.4v6.9v6.9h-6.4h-6.4v6.9v6.9h-6.4H790v3.4v3.4h9.6h9.6v-6.9v-6.9h6.4h6.4V693v-6.9 h9.6h9.6v3.4v3.4h-6.4h-6.4v6.9v6.9H822h-6.4V724v17.2h3.2h3.2v-13.8v-13.8h6.4h6.4v-6.9v-6.9h9.6h9.6v3.4v3.4h-6.4h-6.4v10.3v10.3 h6.4h6.4v6.9v6.9h9.6h9.6v-6.9v-6.9h6.4h6.4v-6.9v-6.9h6.4h6.4v-27.5v-27.5h3.2h3.2v6.9v6.9H918h12.8v3.4v3.4H918h-12.8v24.1v24.1 h25.6h25.8v3.4v3.4h-19.2h-19.2v6.9v6.9H915h-3.2v-6.9V734h-6.4H899v-6.9v-6.9h-3.2h-3.2V734v13.8h-3.2h-3.2v-6.9V734H883h-3.2v6.9 v6.9h-6.4H867v7.2c2.1,0,4.3-0.1,6.4-0.1v0.1h7.4c6.1-0.2,12.2-0.3,18.2-0.5v-6.3v-6.9h3.2h3.2v6.9v6.1c6.5-0.2,12.9-0.5,19.2-0.8 v-5.3v-6.9h9.6h9.6v3.4v3.4h-6.4H931v3.4v1.6c6.5-0.3,12.9-0.6,19.2-1V748v-6.9h6.4h6.4v-10.3v-10.3h-19.2h-19.2v-13.8V693h-3.2 h-3.2v13.8v13.8H915h-3.2v-17.2v-17.2h12.8h12.8v-10.3v-10.3h-12.8h-12.8V662V658.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M738.7,748.1v7.7c2.1,0,4.3,0.1,6.4,0.1V755h3.2h3.2v0.9c2.1,0,4.3,0,6.4,0.1v-1 v-6.9h-9.6H738.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M533.6,748.2c2.1,0.1,4.3,0.3,6.4,0.4v-14.3v-27.5h-6.4h-6.4v-3.4V700h6.4h6.4v-24.1 v-24.1h-16h-4.9c-3.9,2-7.6,3.9-11.1,5.7v1.2v6.9h-3.2h-3.2v-4.9c-2.2,1.1-4.3,2.1-6.4,3.1v8.6h9.6h9.6v-6.9v-6.9h9.6h9.6v17.2V693 h-6.4h-6.4v34.4v19.9c2.1,0.1,4.3,0.3,6.4,0.4v-6.5v-27.5h3.2h3.2v27.5L533.6,748.2L533.6,748.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M866.9,527.8h-6.4h-6.4v6.9v6.9h-8.2c4.1,2.5,8.3,4.8,12.5,6.9h5.4h28.8v3.4v3.4 h-19.2h-0.1c6.7,2.8,13.1,5.1,18.9,6.9h6.9v-10.3v-10.3h-19.2h-19.2v-3.4v-3.4h6.4h6.4v-17.2v-17.2h-6.4h-6.4V497v-3.4h6.4h6.4 v-13.8V466h0.5c-0.7-2.2-1.3-4.5-2-6.9h-5v13.8v13.8h-6.4h-6.4V497v10.3h6.4h6.4v10.3L866.9,527.8L866.9,527.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M482.3,686.1v20.7v20.7h9.6h9.6v-10.3v-10.3h-3.2h-3.2v6.9v6.9h-3.2h-3.2v-51.6V667 c-2.2,1-4.3,2-6.4,2.9v9.5h-16h-8.5c-4.6,1.4-9.1,2.7-13.9,3.8v3.1h19.2h19.2V686.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M440.7,734.3h-9.6v4.6c6.1,0.8,12.5,1.5,19.2,2.3v-6.8L440.7,734.3L440.7,734.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M841.3,279.9h-6.4h-6.4v10.3v10.3h35.3h23.4c0.4-2.5,0.7-4.8,0.9-6.9h-24.3H835v-3.4 v-3.4h6.4h6.4v-10.3v-10.3h-41.7h-41.7v6.9v6.9h-9.6h-9.6v-3.4V273h6.4h6.4v-3.4v-3.4h-6.4h-6.4v-13.8v-13.8h-6.4h-6.4v-24.1v-24.1 h3.2h3.2v13.8V218h6.4h6.4v3.4v3.4h-6.4h-6.4v3.4v3.4h9.6h9.6v-10.3V211h-6.4h-6.4v-10.3v-10.3h6.4h6.4v-20.7V149h19.2h19.2v-13.8 v-13.8h9.6h9.6v3.4v3.4h-6.4h-6.4V142v14h-6.4H790v13.8v13.8h-3.2h-3.2v-13.8V156H774h-9.6v20.7v20.7H758h-6.4v3.4v3.4h6.4h6.4V218 v13.8h6.4h6.4v6.9v6.9h9.6h9.6v-20.7v-20.7h3.2h3.2v6.9v6.9h3.2h3.2v-24.1v-24.1H806h-3.2v13.8v13.8h-6.4H790v6.9v6.9h-3.2h-3.2 v-6.9v-6.9h-3.2h-3.2v10.3V218h6.4h6.4v10.3v10.3h-3.2h-3.2v-6.9v-6.9h-6.4h-6.4v-31v-31h3.2h3.2v13.8v13.8h9.6h9.6v-13.8v-13.8 h9.6h9.6v31v31h-6.4h-6.4v10.3v10.3h16h16v-6.9v-6.9h6.4h6.4v-17.2v-17.2h-6.4h-6.4v-3.4v-3.4h6.4h6.4v-6.9v-6.9H870h22.4v3.4v3.4 h-12.8h-12.8v10.3V204h12.8h12.8v2.8c0.5-3.5,1.1-6.7,1.6-9.7h-8h-12.8v-3.4v-3.4h19.2h2.9c1.5-7.6,2.8-13.8,3.4-20.7h-28.8h-28.8 v6.9v6.9h-6.4h-6.4v10.3V204h6.4h6.4v10.3v10.3h-6.4h-6.4v6.9v6.9h-9.6h-9.6V235v-3.4h6.4h6.4v-6.9V218h6.4h6.4v-3.4v-3.4h-6.4 h-6.4v-27.5V156h-6.3h-6.4v-10.3v-10.3h6.4h6.4v-13.8v-13.8h3.2h3.2v13.8v13.8h6.4h6.4v10.3V156H838h-3.2v-6.9v-6.9h-9.6h-9.6v3.4 v3.4h6.4h6.4v13.8v13.8h3.2h3.2v-6.9v-6.9h6.4h6.4v-17.2v-17.2h-6.4h-6.4v-13.8v-13.8h-9.6h-9.6v6.9v6.9h-12.8H790v13.8v13.8h-19.2 h-19.2v20.7v20.7h-12.8H726v20.7V225h-3.2h-3.2v-7v-6.9H710h-9.6v6.9v6.9h-3.2H694V218v-6.9h-3.4h-3.2v6.9v6.9h-3.2H681v-20.7 v-20.7h-6.4h-6.4v-3.4v-3.4h9.6h9.6v13.8v13.8h9.6h9.6v-6.9v-6.9h3.2h3.2v6.9v6.9h3.2h3.2V194v-10.3h-9.6h-9.6v6.9v6.9H697h-3.2 V187v-10.3h6.4h6.4v-31v-31H697h-9.6v6.9v6.9h-3.2H681v-6.9v-6.9h-16h-16v6.9v6.9h-6.4h-6.4v37.9v37.9h3.2h3.2v-6.9v-6.9h6.4h6.4 v-20.7v-20.7h9.6h9.6v6.9v6.9h9.6h9.6v-10.3v-10.3h-3.2h-3.2v6.9v6.9h-3.2H681v-6.9v-6.9h-6.4h-6.4v-6.9v-6.9H665h-3.2v6.9v6.9 h-6.4H649V163v20.7h-3.2h-3.2v-24.1v-24.1h6.4h6.4v-6.9v-6.9h9.6h9.6v6.9v6.9h9.6h9.6v-6.9v-6.9h3.2h3.2v24.1v24.1h-16h-16V163v-7 H665h-3.2v17.2v17.2h6.4h6.4v20.7v20.7h16h16v-6.9V218h3.2h3.2v17.2v17.2h-6.4h-6.4v34.4v34.4h-6.4h-6.4v27.5v27.5h-3.2H681v-6.9 v-6.9h-9.6h-9.6v6.9v6.9h-6.4H649v10.3V397h6.4h6.4v3.4v3.4h-6.4H649V421v17.2h9.6h9.6v-6.9v-6.9h6.4h6.4v-6.9v-6.9h3.2h3.2v10.3 v10.3H681h-6.4v6.9v6.9h-19.2h-19.2v3.4v3.4h6.4h6.4v3.4v3.4h-9.6h-9.6v-10.3V438h6.4h6.4v-17.2v-17.2h-6.4h-6.4v-3.4V397h6.4h6.4 v-3.4v-3.4h-16h-16v20.7v20.7h-3.2h-3.2v-20.7v-20.7h-6.4h-6.4v-3.4v-3.4H617h25.6v-6.9v-6.9h6.4h6.4V366v-3.4h-9.6h-9.6v6.9v6.9 h-25.6H585v10.3V397h6.4h6.4v20.7v20.7h9.6h9.6v-6.9v-6.9h6.4h6.4v-3.4v-3.4h-6.4H617v-10.3V397h3.2h3.2v6.9v6.9h6.4h6.4v10.3v10.3 h-6.4h-6.4v17.2v17.2h16h16v-6.9V452h12.8H681v-6.9v-6.9h6.4h6.4V421v-17.2h-9.6h-9.6v6.9v6.9h-6.4h-6.4v6.9v6.9h-3.2h-3.2v-10.3 v-10.3h6.4h6.4v-6.9V397H681h12.8v-3.4v-3.4h-19.2h-19.2v-3.4v-3.4h6.4h6.4v-6.9v-6.9h3.2h3.2v6.9v6.9h9.6h9.6v-6.9v-6.9h3.2h3.2 V397v27.5h32h32v3.4v3.4h-6.4h-6.4v6.9v6.9h-3.2H745v-6.9v-6.9h-22.4h-22.4v6.9v6.9h-6.4h-6.4v10.3v10.3h16h16v-6.9v-6.9h6.4h6.4 v-3.4v-3.4h-9.6H713v6.9v6.9h-9.6h-9.6v-3.4v-3.4h6.4h6.4v-6.9v-6.9h16h16v6.9v6.9h9.6h9.6v-6.9v-6.9h6.4h6.4V428v-10.3h-32h-32 v-10.3V397h3.2h3.2v6.9v6.9h22.4h22.4v-10.3v-10.3h-6.4H745v-3.4v-3.4h12.8h12.8v-10.3v-10.3h-6.4h-6.4v-3.4V356h6.4h6.4v-10.3V335 h-12.8H745v-6.9v-6.9h-16h-16v10.3v10.3h6.4h6.4v3.4v3.4h-9.6h-9.6v-6.9V335h-3.2h-3.2v10.3v10.3h16h16v-10.3V335h-6.4h-6.4v-3.4 v-3.4h9.6h9.6v17.2v17.2h-12.8H713v10.3v10.3h6.4h6.4v6.9v6.9h3.2h3.2v-10.3v-10.3h-6.4h-6.4V373v-3.4h12.8H745v-13.8V342h9.6h9.6 v3.4v3.4h-6.4h-6.4v10.3v10.3h6.4h6.4v3.4v3.4h-12.8h-12.8v10.3V397h6.4h6.4v3.4v3.4h-16h-16V397v-6.9H713h-6.4v-13.8v-13.8h-6.4 h-6.4v-17.2v-17.2h6.4h6.4v-20.7v-20.7h3.2h3.2v13.8v13.8h19.2h19.2v6.9v6.9h9.6h9.6v-6.9v-6.9h9.6h9.6v3.4v3.4h-6.2h-6.4v10.3 v10.3h6.4h6.4v3.4v3.4h-6.4h-6.4v20.7v20.7h-6.4h-6.4v10.3v10.3h6.4h6.4v13.8v13.8h9.6h9.6V428v-10.3h-3.2H790v6.9v6.9h-3.2h-3.2 v-13.8v-13.8h-6.4h-6.4v-3.4V397h6.4h6.4v-20.7v-20.7h6.4h6.4v-10.3V335H790h-6.4v-3.4v-3.4h6.4h6.4v-10.3v-10.3h-16h-16v6.9v6.9 h-3.2H758v-6.9v-6.9h-19.2h-19.2v-13.8V280h-6.4h-6.4v-10.3v-10.3h6.4h6.4v-13.8v-13.8h3.2h3.2V249v17.2h-6.4h-6.4v3.4v3.4h6.4h6.4 v13.8v13.8h28.8h28.8v-6.9v-6.9h3.2h3.2v6.9v6.9h9.6h9.6v-6.9v-6.9h3.2h3.2V304v17.2h-3.2h-3.2v-6.9v-6.9H806h-3.2v10.3V328h6.4 h6.4v3.4v3.4h-6.4h-6.4v20.7v20.7h-3.2h-3.2v-6.9v-6.9h-3.2H790v10.3V383h9.6h9.6v-6.9v-6.9h3.2h3.2v6.9v6.9h16h16v-10.3v-10.3 h-6.4h-6.4v-24.1v-24.1h6.4h6.4v-3.4v-3.4H838h-9.6v31v31h6.4h6.4v3.4v3.4h-9.6H822v-13.8v-13.8h-3.2h-3.2v6.9v6.9h-3.2h-3.2v-10.3 v-10.3h6.4h6.4v-31v-31h-9.6h-9.6v6.9v6.9h-3.2h-3.2v-6.9v-6.9h-9.6h-9.6v6.9v6.9h-22.4h-22.4v-24.1v-24.1h3.2h3.2v20.7v20.7h16h16 v-6.9V273h35.3h35.3v3.4L841.3,279.9L841.3,279.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M604.1,624.2h-16h-16v10.3v10.3h9.6h9.6v-3.4V638h-6.4h-6.4v-3.4v-3.4h9.6h9.6v6.9 v6.9h6.4h6.4v3.4v3.4h-32h-32V662v10.3h6.4h6.4v3.4v3.4h-6.4h-6.4v24.1v24.1h9.6h9.6v-13.8v-13.8h6.4h6.4v-13.8v-13.8h3.2h3.2v24.1 v24.1h-3.2h-3.2v-6.9v-6.9h-3.2h-3.2V724v17.2h6.4h6.4v3.4v3.4h-9.6h-9.7v-6.9v-6.9H556h-9.6V748v0.9c2.1,0.1,4.3,0.3,6.4,0.4v-8.2 h3.2h3.2v6.9v1.6c10.5,0.6,21.2,1.2,32,1.7v-6.8v-10.3h-6.4h-6.4v-3.4v-3.4h6.4h6.4v-27.5v-27.5H604h12.8V669v-3.4h-22.4H572v13.8 V693h-6.4h-6.4v13.8v13.8H556h-3.2v-17.2v-17.2h6.4h6.4v-10.3v-10.3h-6.4h-6.4V662v-3.4h32h32v-10.3V638h-6.4H604v-6.9L604.1,624.2 L604.1,624.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M636.2,576h16h16v-24.1v-24.1h-22.4h-22.4v6.9v6.9h-3.2h-1.6c0.3,2,0.6,4.3,0.8,6.9 h3.8h6.4v-6.9v-6.9h16h16V545v10.3h-3h-3.2v-6.9v-6.9h-9.6h-9.6v3.4v3.4h6.4h6.4v6.9v6.9h6.4h6.4v3.4v3.4h-9.6h-9.6V562v-6.9H633 h-9.6v13.8v13.8H617h-3.8c-0.8,1.4-1.6,2.8-2.6,4.1v2.8h9.6h9.6V576v-13.8h3.2h3.2v6.9V576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M636.2,94h3.2h3.2V76.8V59.6H633h-9.6v24.1v24.1h6.4h6.4v3.4v3.4h-9.6H617v-13.8 V87.2h-6.4h-6.4V76.8V66.5h3.2h3.2v6.9v6.9h3.2h3.2V69.9V59.6h-9.6h-9.6v13.8v13.8h-3.2h-3.2v-6.9v-6.9H585h-6.4v-6.9v-6.9h-6.4 h-6.6v-5c-4.2,3.8-8.2,7.8-12,11.9h5.5h12.8v6.9v6.9h6.4h6.4V94v13.8h6.4h6.4v6.9v6.9h3.2h3.2v-10.3V101h-6.4h-6.4v-3.4V94h9.6h9.6 v13.8v13.8h6.4h6.4v3.4v3.4h-16h-16v-6.9v-6.9h-12.8h-12.7v-3.4v-3.4h6.4h6.4V97.5V87.2h-3.2H572V94v6.9h-3.2h-3.2V87.2V73.4H556 h-8.4c-0.4,0.5-0.8,1-1.2,1.5v1.9v3.4h6.4h6.4v20.7v20.7H572h12.8v6.9v6.9h22.4h22.4v-6.9v-6.9h6.4h6.4v-10.3V101H636h-6.4V83.7 V66.5h3.2h3.2v13.8V94H636.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M1040,686.1v-5.5c-2.1-1-4.2-2-6.3-3c-0.1,0-0.1,0-0.1-0.1v1.7v6.9h3.2L1040,686.1 L1040,686.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M833.4,576c-2.3-4.6-3.9-9.5-4.7-14.6c-0.1-0.3-0.1-0.9-0.2-1.6V576h3.2H833.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M892.5,341.9v6.4c1.5-4.6,2.6-9.2,2.5-13.2h-2.5V341.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M1065.6,727.4v-20.7h-3.2h-3.2v27.5v5.9c2.2-0.5,4.4-0.9,6.4-1.4V727.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M1033.6,734.3v3.4v3.4h9.6h9.6v-34.4V687c-2.1-1-4.2-2.1-6.4-3.2v19.5v31h-6.4 H1033.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M661.8,11.4v6.9h-3.2h-3.2v-6.9V6.7c-2.2,0.5-4.3,1.1-6.4,1.7v16.7v20.7h-16h-16 v-3.4V39h12.8h12.8V18.3v-7.9c-2.2,0.7-4.3,1.4-6.4,2.2v19.5h-12.8h-12.8V39v6.9h-16h-16V44c-2.2,1.7-4.3,3.4-6.4,5.1v3.7h6.4h6.4 v6.9v6.9h3.2h3.2v-6.9v-6.9h32h32V39V25.2h6.4h6.4v-6.9v-6.9h3.2h3.2v10.3V32h-6.4h-6.4v13.8v13.8h-6.4H649v24.1v24.1h16h16v-3.4 V101h-12.8h-12.8v-3.4V94h6.4h6.4v-6.9v-6.9h3.2h3.2v6.9V94h6.4h6.4v6.9v6.9h9.6h9.6v-6.9V94h3.2h3.2v6.9v6.9h3.2h3.2V97.5V87.2 h-9.6h-9.6V94v6.9H697h-3.2V94v-6.9h-6.4H681V76.8V66.5h3.2h3.2v6.9v6.9h22.4h22.4V69.9V59.6h-6.4h-6.4v-6.9v-6.9H713h-6.4V32.1 V18.3H697h-9.6v13.8v13.8H681h-6.4v3.4v3.4h9.6h9.6V39V25.2h3.2h3.2V39v13.8h6.4h6.4v6.9v6.9h6.4h6.4V70v3.4h-9.6h-9.6v-6.9v-6.9 h-3.2h-3.2v6.9v6.9H697h-3.2v-6.9v-6.9h-9.6h-9.6v6.9v6.9h-6.4h-6.4v6.9v6.9h-3.2h-3.2V76.8V66.5h6.4h6.4V52.7V39h6.4h6.4V25.2 V11.4h6.4h6.4V8V4.5h-16h-13.1c-1,0.2-1.9,0.4-2.9,0.6L661.8,11.4L661.8,11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M616.9,574.5c-0.2,0.5-0.4,1-0.5,1.5h0.5V574.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M681,489.9v-31h-9.6h-9.6v13.8v13.8h-3.2h-3.2v-6.9v-6.9h-19.2H617v-13.8v-13.8h-3.2 h-3.2v6.9v6.9h-3.2h-3.2V452v-6.9h-6.4h-6.4v-20.7v-20.7H585h-6.4v-13.8v-13.8h-3.2h-3.2v6.9v6.9h-2c2.5,6,4.9,12.7,6.9,20.1 c0,0.2,0.1,0.4,0.1,0.6h1.3h6.4v20.7V452h6.4h6.4v6.9v6.9h6.4h6.4v6.9v6.9h19.2h19.2v6.9v6.9h9.6h9.6v-13.8v-13.8h3.2h3.2v24.1V514 h-3.2h-3.2v-6.9v-6.9h-12.8h-12.7v-6.9v-6.9H633h-9.6v13.8V514h-3.2H617v-13.8v-13.8h-6.4h-6.4v-6.9v-6.9H579 c-0.7,2-1.5,4.3-2.4,6.9h21.1v24.1v24.1h-3.2h-3.2V507v-20.7h-9.6h-7.5c-0.7,2-1.4,4-2.1,5.9v7.9V514h-6.5h-1.5 c-1.7,4.5-3.3,8.7-5,12.5v1.2h-0.5c-1,2.4-2,4.7-3,6.9h0.3h9.6v-6.9v-6.9h6.4h6.4V507v-13.8h3.2h3.2v17.2v17.2h-6.4h-6.4v13.8v13.8 h-9.6h-9.6v-3.4v-3.4h6.4h6.4V545v-3.4h-13.3c-1.9,3.6-3.8,7-5.9,10.2v3.6v6.9h16h9.3c2.2-0.9,4.5-1.9,6.7-3v-3.9v-6.9h9.6h9.2 c2.4-1.6,4.7-3.3,6.9-5.1v-1.7h-12.8h-12.8v-3.4v-3.4h12.8H604V514v-20.7h3.2h3.2v13.8v13.8h9.6h9.6v-13.8v-13.8h3.2h3.2v6.9v6.9 h12.8h12.8v3.4v3.4h-12.8H636v3.4v3.4h22.6H681V489.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M584.9,556c0.4-0.2,0.8-0.4,1.2-0.6h-1.2V556z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M1007.9,706.8h-6.4h-6.4v24.1v18c2.9-0.3,5.7-0.5,8.5-0.8h-2.1v-17.2v-17.2h9.6h9.6 v6.9v6.9h9.6h9.6v-17.2V693h-6.3h-6.4v-10.3v-8.2c-2.2-1-4.3-2-6.4-2.9v11v17.2h6.4h6.4v10.3v10.3h-3.2h-3.2v-6.9v-6.9h-6.4h-6.4 V669c-3.2-1.3-6.4-2.5-9.3-3.5h-3.5h-6.4v3.4v3.4h6.4h6.4v10.3V693h-3.2h-3.2v-6.9v-6.9h-6.4h-6.4v-10.3v-8.6 c-2.2-0.6-4.3-1.2-6.4-1.7v10.3v17.2h6.4h6.4v6.9v6.9h6.4h6.4v3.4L1007.9,706.8L1007.9,706.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M386.2,720.6h-12.9h-6.6c-0.1,0.2-0.1,0.5-0.1,0.7c0.1,2.1,2.7,4.1,7.5,6.1h5.6v2 c1.9,0.6,4.1,1.2,6.4,1.8v-0.3v-10.3H386.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M392.6,732.6c2,0.4,4.2,0.9,6.4,1.3v-16.8v-17.2h19.2h19.2v-15.5 c-1.8,0.4-3.9,0.8-6.4,1.4v7.2h-3.2h-3.2v-5.5c-2,0.6-4.2,1.2-6.4,2v3.6h-9.5c-5.1,2.1-10.5,4.7-16.1,8v5.8h-3.2h-3.2v-2 c-2.2,1.3-4.4,2.7-6.4,4v4.9h6.4h6.4v13.8V732.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M693.8,741.2h16h16v10.3v4.1c2.1,0,4.3,0.1,6.4,0.1V755v-13.8H745h12.8v-6.9v-6.9 h3.2h3.2v6.9v6.9H777h12.8v6.9v6.9h3.2h3.2v-10.3v-10.3h-12.6h-12.8v-6.9v-6.9h-9.6h-9.6v6.9v6.9h-32h-32v13.8v6.7 c2.1,0.1,4.3,0.1,6.4,0.2l0,0v-13.9H693.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M988.7,734.3h-6.4h-6.4v-3.4v-3.4h6.4h6.4v-10.3v-10.3h-25.6h-25.6v-3.4v-3.4h25.6 h25.6v-3.4V693h-6.4h-6.4v-13.8v-13.8h-3.2h-3.2v13.8V693h-9.6h-9.6v-3.4v-3.4h6.4h6.4v-10.3v-10.3h-6.5h-6.4V662v-3.4H963h12.8 V657c-6.7-1.7-13.4-3.3-20.5-5.3h-1.9h-16v-5.8c-5.9-2.1-12.2-4.7-19.2-7.8v6.7h6.4h6.4v6.9v6.9h6.4h6.4v6.9v6.9h6.4h6.4v3.4v3.4 h-6.4h-6.4v6.9v6.9h-6.4H931v10.3v10.3h25.6h25.6v3.4v3.4h-6.4h-6.4v10.3V741h6.4h6.4v3.4v3.4h-12.8h-12.8v3.7 c11.2-0.7,21.9-1.5,32-2.3v-4.8L988.7,734.3L988.7,734.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M373.3,713.2c-0.2,0.2-0.4,0.3-0.7,0.5h0.7V713.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M401.1,734.3c3.4,0.6,6.9,1.2,10.7,1.8v-1.8h-6.4H401.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M1072,737.2c3.4-0.9,6.5-1.9,9.2-2.9h-9.2V737.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M885.8,307.5h-6.1v3.4v3.4h4.6C884.8,312.1,885.3,309.8,885.8,307.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M540,269.6v-3.4h-3.8c0.2,2.2,0.4,4.5,0.6,6.9h3.2V269.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M501.5,686.1h12.8h12.8v-10.3v-10.3h-3.2h-3.2v6.9v6.9h-12.8h-12.8v10.3v10.3h6.4 h6.4V724v22.4c2.1,0.2,4.3,0.3,6.4,0.5V724v-31h-6.4h-6.4v-3.4V686.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M514.4,156h-1.3c-0.5,6.6-0.6,13.6-0.2,20.7h1.5h6.4V187v10.3h-3.2h-1.4 c0.7,2.4,1.4,4.7,2.3,6.9h2.3h6.4v-6.9v-6.9h3.2h3.2v13.8V218h6.4h6.4v3.4v3.4H540h-6.4v3.4v3.4h16h16v-20.7v-20.7h3.2h3.2v6.9v6.9 h12.8h12.8v14v13.8h3.2h3.2v-37.9V156h-3.2h-3.2v20.7v20.7H588h-9.6v-6.9v-6.9h-9.6h-9.6v20.7V225H556h-3.2v-7v-6.9h-6.4H540v-10.3 v-10.3h3.2h3.2v6.9v6.9h3.2h3.2V194v-10.3h-6.4H540v-6.9v-6.9h-3.2h-3.2v6.9v6.9h-3.2h-3.2v-6.9v-6.9h-6.4h-6.4V163V156L514.4,156z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M514.4,189.5v-5.9h-0.9C513.7,185.5,514,187.5,514.4,189.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M706.7,755h3.2h3.2v0.4c2.1,0,4.3,0.1,6.4,0.1V755v-6.9h-9.6h-9.6v7 c2.1,0,4.3,0.1,6.4,0.1V755z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M538.1,562.6c-2.2,2.4-3.9,4.1-4.5,5.4v1.1h-0.2c0,0.1,0.1,0.3,0.1,0.4 c1.1,2,7.9,1.8,17.4-0.4h-4.4h-6.4v-8.7C539.4,561.1,538.8,561.9,538.1,562.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M527.2,218.2v-7.1h-5.4C523.4,213.7,525.1,216.1,527.2,218.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M668.2,197.3h-9.6H649v27.5v27.5h-6.4h-6.4v10.3V273h6.4h6.4v3.4v3.4h-9.6h-9.6V266 v-13.8h-16h-16v10.3V273h6.4h6.4v10.3v10.3H585h-25.6v6.9v6.9h-3.2H553v-6.9v-6.9h-6.4h-6.4v-6.9v-6.9h-3.1c0,2.4-0.1,4.9-0.2,7.5 c-0.4,5.8-1,9.9-1.7,13.2h5h6.4v6.9v6.9h9.6h9.6v-6.9v-6.9h28.8h28.8v6.9v6.9h6.4h6.4v3.4v3.4h-9.6H617v-6.9v-6.9h-9.6h-9.6v13.8 V335h-3.2h-3.2v-13.8v-13.8h-9.6h-9.6v17.2v17.2h3.2h3.2V328v-13.8h3.2h3.2v24.1v24.1h-3.2h-3.2v-6.9v-6.9h-6.4h-6.6V335v-13.8H556 h-9.6v6.9v6.9h-3.2H540v-13.8v-13.8h-6.5c-0.4,2.1-0.7,4.3-0.8,6.9h0.9v10.2c1,6.2,2.8,12.1,5,17.3h4.6h9.6V335v-6.9h3.2h3.2v13.8 v13.8h6.4h6.4v3.4v3.4h-6.4h-6.4v5.9c1.7,2.9,4,7,6.4,11.9v-0.6v-10.3h12.8h12.8v-6.9v-6.9h3.2h3.2v6.9v6.9h3.2h3.2v-10.3v-10.3 h-6.4h-6.4v-3.4V342h6.4h6.4v-13.8v-13.8h3.2h3.2v27.5v27.5h9.6h9.6v-13.8v-13.8h3.2h3.2v6.9v6.9h22.6H681v-10.3V335h-6.4h-6.4 v-3.4v-3.4h6.4h6.4v-13.8v-13.8h3.2h3.2v6.9v6.9h3.2h3.2v-24.1v-24.1h-9.6h-9.6v10.3v10.3h3.2h3.2v-6.9V273h3.2h3.2v10.3v10.3H681 h-6.4v13.8v13.8h-6.4h-6.4v10.3v10.3h6.4h6.4v3.4v3.4h-16h-16v-6.9V335H633h-9.6v13.8v13.8h-3.2H617v-17.2v-17.2h16h16v6.9v6.9h3.2 h3.2v-10.3v-10.3H649h-6.4v-6.9v-6.9h-6.4h-6.4v-6.9v-6.9h-6.4H617V280v-13.8h-6.4h-6.4v-3.4v-3.4h9.6h9.6V273v13.8h16h16v-10.3 v-10.3H649h-6.4v-3.4v-3.4h6.4h6.4v-27.5v-27.5h3.2h3.2v20.7v20.7h12.8h12.8v3.4v3.4h-12.8h-12.8v27.5v27.5h-3.2h-3.2v-6.9v-6.9 h-9.6h-9.6v3.4v3.4h6.4h6.4v6.9v6.9h9.6h9.6v-27.5v-27.5H681h12.8v-6.9v-6.9h6.4h6.4v-3.4v-3.4h-19.2h-19.2V218L668.2,197.3 L668.2,197.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M610.5,527.8v9.8c1-1,2-2,2.9-3c1-1.1,1.7-1.9,2.3-2.7c0.5,1.1,0.9,1.9,1.2,2.4v-6.6 h-3.2L610.5,527.8L610.5,527.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M604.1,39V27.1c-2.2,1.2-4.3,2.4-6.4,3.7V32h-2c-3.6,2.2-7,4.5-10.4,6.9h9.2 L604.1,39L604.1,39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M488.7,744.8v-3.6h3.2h3.2v4.2c2.1,0.2,4.3,0.3,6.4,0.5v-4.7v-6.9h-9.6h-9.6v10 C484.4,744.5,486.6,744.7,488.7,744.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M559.2,637.9h-9.6h-4.1c-4.4,2.4-8.4,4.5-11.9,6.3v0.6h16h16V631v-4.9 c-2.2,1.4-4.3,2.7-6.4,3.9V637.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M591.3,462.4V459h-6.4h-0.7c-0.9,1.2-1.7,3.3-3,6.9h10L591.3,462.4L591.3,462.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M546.1,355.7h0.3v0.4c2.3,3.1,4.5,5.3,6.4,6.4v-13.7h-11 C543.2,351.4,544.7,353.7,546.1,355.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M629.7,25.2V15c-2.2,0.9-4.3,1.7-6.4,2.7v0.7h-1.5c-3.8,1.7-7.6,3.5-11.3,5.4v1.5 h9.6h9.6V25.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#F9F2F2"
    },
    d: "M629.7,211.1v-34.4v-34.4h-3.2h-3.2v37.9V218h6.4h6.4v10.3v10.3h-3.2h-3.2v-6.9v-6.9 h-6.4h-6.4v-41.3v-41.3h-16h-16V156v13.8h-3.2h-3.2v-20.7v-20.7h-9.6h-9.6v20.7v20.7h-3.2h-3.2V156v-13.8h-6.4h-6.4v-3.4v-3.4h6.4 h6.4v-24.1V87.2h-6.4h-6.4v-3.9c-2.3,3.3-4.5,6.5-6.4,9.6v8.1H529c-3.5,6.5-6.1,12.6-8.2,18.2v2.5h9.6h9.6v-3.4v-3.4h-6.4h-6.4 v-3.4v-3.4h6.4h6.4v-6.9V94h3.2h3.2v17.2v17.2h-12.8h-12.8v6.9v6.9h-3.2h-2.9c-0.4,2.2-0.7,4.5-1,6.9h3.8h9.6v-6.9v-6.9h3.2h3.2 v6.9v6.9h6.4h6.4v3.4v3.4h-12.7h-12.8v3.4v3.4h12.8h12.8v6.9v6.9h9.6h9.6V156v-20.7h3.2h3.2V156v20.7h6.4h6.4v6.9v6.9h3.2h3.2 v-20.7v-20.7h9.6h9.6v44.8v44.8h-9.6h-9.6v-13.8v-13.8h-9.6H572v24.1v24.1h6.4h6.4v3.4v3.4h-6.4H572v6.9v6.9h-9.6h-9.6v-3.4V273 h6.4h6.4v-17.2v-17.2H556h-9.6v6.9v6.9h-3.2H540v-6.9v-6.9h-8.5c0.3,2.1,0.7,4.3,1.3,6.9h0.8v4.2c0.6,2.9,1.2,6.1,1.7,9.6h7.9h9.6 v-6.9v-6.9h3.2h3.2v10.3v10.3h-6.4h-6.4v10.3v10.3h28.8H604v-3.4v-3.4h-12.8h-12.8v-3.4V273h6.4h6.4v-10.3v-10.3h-6.4h-6.4v-17.2 V218h3.2h3.2v13.8v13.8h16h16v-6.9v-6.9h3.2h3.2v6.9v6.9h9.6h9.6v-17.2v-17.2H636h-6.3V211.1z"
  })), /*#__PURE__*/React.createElement("text", {
    id: "question-mark",
    transform: "matrix(1 0 0 1 564.353 533.1271)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'MyriadPro-Regular'",
      fontSize: 600
    }
  }, "?"), /*#__PURE__*/React.createElement("text", {
    id: "or",
    transform: "matrix(1 0 0 1 604.353 423.1271)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'MyriadPro-Regular'",
      fontSize: 160
    }
  }, "OR"), /*#__PURE__*/React.createElement("path", {
    id: "right-bubble",
    style: {
      fill: "#FFFFFF",
      stroke: "#000000",
      strokeWidth: 11,
      strokeMiterlimit: 10
    },
    d: "M1181.9,42.9 c-144.2,0-261.1,84.2-261.1,188.1c0,46,22.9,88.1,60.9,120.8l-63.6,153.7L1077,403.4c32.1,10.1,67.6,15.8,104.9,15.8 c144.2,0,261.1-84.2,261.1-188.1S1326.1,42.9,1181.9,42.9z"
  }), /*#__PURE__*/React.createElement("text", {
    id: "date",
    transform: "matrix(1.032 0 0 1 957.162 189.0054)",
    style: {
      fontFamily: "'Arial-Black'",
      fontSize: "40.3034px"
    }
  }, "date"), /*#__PURE__*/React.createElement("text", {
    id: "venue",
    transform: "matrix(1.032 0 0 1 957.162 249.0054)",
    style: {
      fontFamily: "'Arial-Black'",
      fontSize: "40.3034px"
    }
  }, "venue"), /*#__PURE__*/React.createElement("text", {
    id: "location",
    transform: "matrix(1.032 0 0 1 957.162 309.0054)",
    style: {
      fontFamily: "'Arial-Black'",
      fontSize: "40.3034px"
    }
  }, "location"), /*#__PURE__*/React.createElement("path", {
    id: "left-bubble",
    style: {
      fill: "#FFFFFF",
      stroke: "#000000",
      strokeWidth: 11,
      strokeMiterlimit: 10
    },
    d: "M5.5,246.3 c0,103.9,116.9,188.1,261.1,188.1c37.3,0,72.8-5.7,104.9-15.8l158.9,102.1L466.8,367c38-32.7,60.9-74.8,60.9-120.8 c0-103.9-116.9-188.1-261.1-188.1S5.5,142.4,5.5,246.3z"
  }), /*#__PURE__*/React.createElement("text", {
    id: "next",
    transform: "matrix(1 0 0 1 50.353 283.1271)",
    style: {
      fill: "#000000",
      stroke: "#000000",
      fontFamily: "'MyriadPro-Regular'",
      fontSize: 150
    }
  }, "NEXT"), /*#__PURE__*/React.createElement("text", {
    id: "play",
    transform: "matrix(1 0 0 1 50.353 243.1271)",
    style: {
      fill: "#000000",
      stroke: "#000000",
      fontFamily: "'MyriadPro-Regular'",
      fontSize: 90
    }
  }, "CLICK ME"), /*#__PURE__*/React.createElement("text", {
    id: "play",
    transform: "matrix(1 0 0 1 50.353 333.1271)",
    style: {
      fill: "#000000",
      stroke: "#000000",
      fontFamily: "'MyriadPro-Regular'",
      fontSize: 90
    }
  }, "TO PLAY"));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewBowie);
export default __webpack_public_path__ + "static/media/new-bowie.ba3ac63d.svg";
export { ForwardRef as ReactComponent };